    import {lazy} from "react";

const routes = [
    {
        path: 'mail',
        component: lazy(() => import('./components/email/index'))
    },
    {
        path: 'report/:namespace',
        component: lazy(() => import('./components/email/report/detail-report'))
    },
    {
        path: 'template',
        component: lazy(() => import('./components/email/template/template'))
    },
    {
        path: 'template/:_id/:method',
        component: lazy(() => import('./components/email/template/template'))
    },
    {
        path: 'image',
        component: lazy(() => import('./components/image/upload-image'))
    },
    {
        path: 'qr-code',
        component: lazy(() => import('./components/qr-code/qrcode'))
    },
    {
        path: 'link',
        component: lazy(() => import('./components/link/short-link'))
    },
    {
        path: 'reddit',
        component: lazy(() => import('./components/reddit/reddit'))
    },
    {
        path: 'tiktok',
        component: lazy(() => import('./components/tiktok/tiktok'))
    }
];
export default routes;